export default "__VITE_ASSET__BFhCBMUu__"